export default __webpack_public_path__ + "static/media/photo--sm--40.e2ab4c06.jpg";